var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg57(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7h8a6 6 0 0 1 6 6v1h2v2H0v-2h2v-1a6 6 0 0 1 6-6Zm0 2a4 4 0 0 0-4 4v1h12v-1a4 4 0 0 0-4-4H8Zm5-5V2h2v2h-2ZM9 2v2h2V2H9Zm2 4a1 1 0 0 1 1 1h-2a1 1 0 0 1 1-1Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg57);
export default __webpack_public_path__ + "static/media/57.f2a381280f462f3f623b658c7b94c451.svg";
export { ForwardRef as ReactComponent };